import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { problemCards } from '../data/content';
export function ProblemSection() {
  return <Section tone="dark" className="py-14 sm:py-16 lg:py-20" data-id="element-101" data-mp="2lu4mzfde3g5n">
      <SectionHeader tone="dark" title="¿Sentís que organizar Europa se vuelve más confuso cuanto más investigás?" data-id="element-102" data-mp="30hhfxp5j0o62" />

      <ul className="mx-auto mt-9 grid max-w-[46rem] grid-cols-1 gap-2.5 sm:mt-11 sm:grid-cols-2" data-id="element-103" data-mp="2vpplv4n5w0b6">
        {problemCards.map(card => <li key={card} className="rounded-lg border border-polar/12 bg-white/[0.04] px-4 py-3.5 font-sans text-[12.5px] leading-snug text-polar/85 sm:text-[13px]" data-id="element-104" data-mp="39jyyntlz2yob">
            “{card}”
          </li>)}
      </ul>

      <p className="mx-auto mt-9 max-w-[42rem] rounded-lg border border-travertino/40 px-5 py-6 text-center font-display text-[19px] font-bold leading-snug text-polar sm:mt-11 sm:px-8 sm:text-[24px]" data-id="element-105" data-mp="3jdpigl75mkxo">
        El problema no es que falte información. Es que está dispersa y cuesta transformarla en un
        viaje concreto.
      </p>

      <p className="mx-auto mt-6 max-w-[34rem] text-center font-sans text-[13px] leading-relaxed text-polar/60 sm:text-[13.5px]" data-id="element-106" data-mp="jdwmx3wkbyzj">
        Europa por Primera Vez fue creada para ayudarte justamente con eso.
      </p>
    </Section>;
}